export const homeData = {
  title: 'Participe das Nossas Rifas!',
  sub_title:
    'Concorra a prêmios incríveis com apenas alguns cliques. É fácil, rápido e seguro!',
  bannerImage: '/banner.png',
  howItWorks: [
    {
      title: 'Escolha sua Rifa',
      description: 'Navegue pelas opções e selecione sua rifa favorita.',
    },
    {
      title: 'Compre seu Bilhete',
      description: 'Finalize a compra de forma rápida e segura.',
    },
    {
      title: 'Aguarde o Sorteio',
      description: 'O sorteio será realizado na data informada.',
    },
  ],
}

export const fakeRifas = [
  {
    id: 1,
    title: 'Carro dos Sonhos',
    image:
      'https://s2-autoesporte.glbimg.com/E1sf1iS9BMTiP02MCuaFHCbl10c=/0x0:1980x1321/888x0/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_cf9d035bf26b4646b105bd958f32089d/internal_photos/bs/2020/d/j/qQoWftR5KFEIpuXZBBTA/376505-932276-mclaren-gtr-000.jpg',
    price: 'R$ 10,00',
  },
  {
    id: 2,
    title: 'Moto Velocidade',
    image:
      'https://imagens.ebc.com.br/b3y7QhZmOsjGl8pcw0XhsbyJoK4=/1170x700/smart/https://agenciabrasil.ebc.com.br/sites/default/files/thumbnails/image/eric_granado_motovelocidade3.jpg?itok=G_1BkF72',
    price: 'R$ 15,00',
  },
  {
    id: 3,
    title: 'Viagem Inesquecível',
    image:
      'https://forbes.com.br/wp-content/uploads/2024/03/Life_tendencias-de-viagem-2024.jpg',
    price: 'R$ 20,00',
  },
]

export const testimonials = [
  {
    id: 1,
    name: 'Claudiane Moura',
    username: '@lojaperigosa',
    text: 'Hoje iniciei minha primeira campanha no site... Amando. Os valores caem na conta automaticamente.',
    platform: 'instagram',
  },
  {
    id: 2,
    name: 'Angelica Silva',
    username: '@djAngelrj',
    text: 'Fiz e funcionou.. o Pix vai direitinho na conta, eles descontam primeiro a taxa e a sequência cai na sua conta',
    platform: 'youtube',
  },
  {
    id: 3,
    name: 'Dayse Correia',
    username: '@daysecorreia4595',
    text: 'Já fiz e é muito seguro, o dinheiro cai direto na conta',
    platform: 'youtube',
  },
  {
    id: 4,
    name: 'Samuel',
    username: '@xsonstars1521',
    text: 'Muito bem a melhor que já vi 🎉🎉🎉',
    platform: 'youtube',
  },
  {
    id: 5,
    name: 'Isabella',
    username: '@Luabellaa',
    text: 'Sim, deu super certo, consegui um ótimo lucro, essa plataforma é muito confiável, tirou todas minhas dúvidas, me passou muita segurança!',
    platform: 'youtube',
  },
  {
    id: 6,
    name: 'Guilherme Silva',
    username: '@GuilhermeSilva-wi3to',
    text: 'Parabéns aos desenvolvedores do site, muito Bom...',
    platform: 'youtube',
  },
]
export const faqs = [
  {
    question: 'Como funciona o pagamento?',
    answer:
      'O pagamento é realizado via Pix, com confirmação automática. Você recebe seu comprovante por e-mail.',
  },
  {
    question: 'É seguro participar das rifas?',
    answer:
      'Sim! Utilizamos tecnologias seguras para proteger seus dados e garantir sorteios transparentes.',
  },
  {
    question: 'Quando ocorre o sorteio?',
    answer:
      'A data do sorteio é informada em cada rifa, e os vencedores são divulgados em nossa plataforma.',
  },
]
export const homeStats = [
  {
    title: 'Clientes utilizando',
    value: '+20.000 mil',
    description: 'Com campanhas ativas ou já finalizadas',
  },
  {
    title: 'Pedidos feitos',
    value: '+7 milhões',
    description: 'Através da plataforma',
  },
  {
    title: 'Atendimentos',
    value: '+2.000 mil',
    description: 'Todos os meses',
  },
]
